module.exports = __webpack_public_path__ + "static/media/www.73993668.svg";